export const getRenderValue = <T>(value: T, howLong = 4) => value || '-'.repeat(howLong);
